import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ClipboardService } from 'node_modules/ngx-clipboard';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Location } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ContactRishiDialogComponent } from '../contact-rishi-dialog/contact-rishi-dialog.component';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss']
})
export class StoreComponent implements OnInit {
 searchText: string = '';
  type: string = '';
  loggedIn =  false;
  formClicked =  false;
  data:any = [];
  item:any = {};
  itemType:any = {};
  message = '';
  error = '';
  redirectTo = '';
  Location = null;
  constructor(public cs: CommonService, private location: Location, public http: HttpClient
    , public dialog: MatDialog, private router: Router, private _snackBar: MatSnackBar
    , private route: ActivatedRoute, private _clipboardService: ClipboardService) {
    if (this.cs.user.access_token) {
      this.loggedIn = true;
    }
  }

  ngOnInit() {
    this.redirectTo = this.cs.redirectTo;
    this.cs.redirectTo = '';
    this.route.paramMap.subscribe((params: any) => {
      this.searchText = '';
      if(params != null && params.params != null && params.params.id != null && params.params.id.trim() != ''){
        this.searchData(params.params.id.toLowerCase());
      } else {
        this.searchData('');
      }
    });
  }

  selectItem(item) {
    this.item = item;
    this.item.DescriptionFormatted = this.item.Description.replace(/\n/g, '<br/>')
  }

  openContactRishiDialog(item) {
    const dialogRef = this.dialog.open(ContactRishiDialogComponent, {
      width: '400px',
      data: item
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log("Form submitted:", result);
        // Handle the data (send to backend, WhatsApp API, etc)
      }
    });
  }

  clearData(){
    this.item = {};
    this.itemType = {};
    this.data = [];
  }

  share(item){
    var url = 'https://item.rishiyog.org/api/public/detail/item/' + item.Id;
    this._clipboardService.copy(url);
    this._snackBar.open("Copied to Clipboard", "", {
      duration: 2000,
    });
  }

  search(){
    this.type = '';
    this.searchData(this.searchText);
  }

  searchData(id){
    this.clearData();
    this.clearMessageAndError();
    var param = '';
    if(id != null && id != ''){
      param = '?keyword=' + id;
    }
    this.cs.request('/public/products' + param, 'get').then((res: any) => {
      if (res.Status == 200) {
        if(isNaN(id.toString()) == false && id.toString().trim() != "0" && res.Data != null && res.Data.length == 1){
          this.selectItem(res.Data[0]);
        }else {
          this.data = res.Data;
        }
      } else {
        this.error = res.Message;
      }
    }).catch((err) => {
    });
  }

  clearMessageAndError(){
    this.error = '';
    this.message = '';
  }
}
